import useMediaQuery from "hooks/use-media-query";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "store/selector";
import { createCount, fetchPlanInfo } from "store/services";
import { actions } from "store/slice";
import { getItem } from "utils/local-storage";
import DesktopHeader from "./desktop-header";
import MobileHeader from "./mobile-header";

const Header = () => {
  const dispatch = useDispatch();
  const { token } = useSelector(getUser);
  const { isDesktop } = useMediaQuery();

  // Fetch visit counter
  useEffect(() => {
    const storedToken = getItem("the_main_app");
    if (!storedToken) return;

    createCount(storedToken)
      .then((res) => {
        if (res?.data?.success) {
          dispatch(actions.setCount(res?.data?.count));
        }
      })
      .catch((err) => console.error(err));
  }, [dispatch, token]);

  // Fetch subscription plan when user is authenticated
  useEffect(() => {
    const currentUser = getItem("current_user");
    const userId = currentUser?.userId;
    const storedToken = getItem("the_main_app");
    if (!userId || !storedToken) return;

    fetchPlanInfo(userId, storedToken)
      .then((res) => {
        if (res?.data?.success) {
          dispatch(
            actions.setPlan({
              plan: res.data.plan || "free",
              planExpiresAt: res.data.planExpiresAt || null,
            })
          );
        }
      })
      .catch((err) => console.error("Plan fetch error:", err));
  }, [dispatch, token]);

  useEffect(() => {
    dispatch(actions.setToken(getItem("the_main_app")));
    getItem("current_user") &&
      dispatch(actions.setLoginSuccess(getItem("current_user")));
    const url = window.location.href;
    url.includes("profile") && dispatch(actions.setEditProfile(true));
    url.includes("profileedit") && dispatch(actions.setEditProfile(false));
  }, [dispatch, token]);

  return (
    <div className="lime-header" style={{ backgroundColor: "#f7f8fa" }}>
      {isDesktop ? <DesktopHeader /> : <MobileHeader />}
    </div>
  );
};

export default Header;
